// Conversion tracking without personal data: event name, page path and a short CTA label only.
const API = process.env.REACT_APP_BACKEND_URL;
const ALLOWED = new Set(['cta_click', 'form_start', 'form_submit', 'access_register']);

// Strip tokens/ids from paths (e.g. /passport/view/<token>) and lower-case them.
const cleanPath = (path) => {
  const p = (path || '/').toLowerCase().split(/[?#]/)[0];
  if (p.startsWith('/passport/view/')) return '/passport/view';
  if (p.startsWith('/access/reset-password')) return '/access/reset-password';
  return p.replace(/[^a-z0-9\-/]/g, '').slice(0, 80) || '/';
};

export const track = (event, label = '') => {
  if (!ALLOWED.has(event)) return;
  const page = cleanPath(window.location.pathname);
  const safeLabel = String(label).replace(/[^\w\s\-&/]/g, '').slice(0, 60);
  // PostHog only captures once the visitor has accepted cookies (opt-out by default).
  try {
    if (window.posthog?.has_opted_in_capturing?.()) window.posthog.capture(event, { page, label: safeLabel });
  } catch (e) { /* analytics must never break the UI */ }
  const body = JSON.stringify({ event, page, label: safeLabel });
  if (navigator.sendBeacon) {
    navigator.sendBeacon(`${API}/api/events`, new Blob([body], { type: 'application/json' }));
  } else {
    fetch(`${API}/api/events`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
  }
};

// Global listeners: [data-cta] clicks → cta_click; first focus inside form[data-track-form] → form_start.
export const installTracking = () => {
  const started = new WeakSet();
  const onClick = (e) => {
    const el = e.target.closest?.('[data-cta]');
    if (el) track('cta_click', el.getAttribute('data-cta'));
  };
  const onFocus = (e) => {
    const form = e.target.closest?.('form[data-track-form]');
    if (form && !started.has(form)) {
      started.add(form);
      track('form_start', form.getAttribute('data-track-form'));
    }
  };
  document.addEventListener('click', onClick, true);
  document.addEventListener('focusin', onFocus, true);
  return () => {
    document.removeEventListener('click', onClick, true);
    document.removeEventListener('focusin', onFocus, true);
  };
};
